import { Center } from '@chakra-ui/react';

interface ProductConfiguratorRadioButtonProps {
  isActive: boolean;
}

export function ProductConfiguratorRadioButton({
  isActive,
}: ProductConfiguratorRadioButtonProps) {
  return (
    <Center
      as="span"
      flexShrink={0}
      boxSize="xs"
      borderColor={isActive ? 'gray.600' : 'blackAlpha.500'}
      borderWidth={1}
      borderRadius="full"
      _before={{
        pos: 'absolute',
        content: "''",
        boxSize: '4xs',
        bgColor: 'gray.600',
        borderRadius: 'full',
        transform: 'var(--dot-size)',
        transitionProperty: 'common',
        transitionDuration: 'fast',
      }}
    />
  );
}
